import { css } from "lit";
export default css `
    :host {
        color: var(--font-color);
        font-family: var(--font-stack), monospace;
        background: none;
    }
    
    .jsonpath {
        background: none;
        border: none;
    }
    
    .jsonpath:hover {
        color: var(--font-color);
    }

    .jsonpath.selected:hover {
        color: var(--background-color);
    }
    
    .bracket {
        color: var(--secondary-color);
        font-family: var(--font-stack-bold), monospace;
        text-shadow: 0 0 10px var(--secondary-color);
    }
    
    .bracket-nested {
        color: var(--tertiary-color);
    }
    
    .param {
        color: var(--primary-color);
        font-family: var(--font-stack), monospace;
      
        font-weight: normal;
    }

    .param-nested {
        color: var(--primary-color);
        font-family: var(--font-stack-bolditalic), monospace;
        text-shadow: 0 0 10px var(--primary-color);
        font-weight: normal;

    }
    
    .param:hover {
        //text-decoration: underline;
        //cursor: pointer;
    }
    
    .dot {
        color: var(--font-color-sub2)
    }
    
    .dollar {
        color: var(--terminal-yellow)
    }
    
    .jsonpath {
        color: var(--font-color-sub1);
    }
    
    .selected {
        color: var(--background-color)
    }

    .selected .bracket {
        color: var(--background-color)
    }

    .selected .bracket-nested {
        color: var(--background-color)
    }

    .selected .param {
        color: var(--background-color)
    }

    .selected .param-nested {
        color: var(--background-color)
    }
    
    
    
`;
